import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PctInfoFascicolo } from '../../models/sections/pct-info-fascicolo';
import { PdaRegister } from '../../models/typological/pda-registers';
import { PdaDataStore } from '../../store/pda-store';
import { SectionsServiceTsService } from '../../utils/Service/sections.service.ts.service';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { PdaAccessToken, PdaAuthService } from '../../utils/Service/pda-auth.service';
import { PdaDelegation } from '../../models/typological/pda-delegati';

@Component({
  selector: 'pda-fascicolopct-edit',
  templateUrl: './pda-fascicolopct-edit.component.html'
})
export class PdaFascicolopctEditComponent implements OnInit {

  title: string = "Modifica Fascicolo Processo Telematico";
  idFascicoloPct: string;
  fascicoloPct: PctInfoFascicolo;
  fascicoloPctForm: FormGroup;

  registroOptions: PdaRegister[] = [];
  registroValue: PdaRegister = null;

  deleganteOptions: PdaDelegation[] = [];
  deleganteValue: PdaDelegation = null;

  constructor(private sectionService: SectionsServiceTsService,
    private campiForm: FormBuilder,
    private dialogRef: DialogRef,
    private pdaAuthService: PdaAuthService
  ){
  }

  ngOnInit(): void {
    this.fascicoloPct = PdaDataStore.getInstance().pctInfoFascicolo;
    this.createForm();
    this.mapRegistri();
    this.mapDelegations();
  }

  createForm(){
    this.fascicoloPctForm = this.campiForm.group({
      annoRuolo: [this.fascicoloPct.annoRuolo],
      numeroRuolo: [this.fascicoloPct.numeroRuolo],
      registro: [null, Validators.required],
      delegante: [null]
    });
    this.registroValue = null;
    this.deleganteValue = null;
  }

  async mapRegistri(){
    if(PdaDataStore.getInstance().pdaRegisters == null){
      this.sectionService.getRegisters().subscribe((res) => {
        PdaDataStore.getInstance().pdaRegisters = res;
        this.setRegistriOptions(PdaDataStore.getInstance().pdaRegisters);
      });
    }
    else{
      this.setRegistriOptions(PdaDataStore.getInstance().pdaRegisters);
    }
  }

  async mapDelegations(){
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    this.sectionService.getDelegheRicevute({token: token}).subscribe((res) => {
      if(res.deleghe && res.deleghe.length > 0){
        res.deleghe.forEach((r) => this.mapDelega(r));
        if(this.fascicoloPct.cfDelegante) {
          this.deleganteValue = this.deleganteOptions.filter((opt) => opt.id == this.fascicoloPct.cfDelegante)[0];
          this.fascicoloPctForm.controls['delegante'].setValue(this.deleganteValue);
        }
      }
    });
  }

  mapDelega(r) {

    let delega: PdaDelegation = {id: r.codiceFiscale, descrizione: r.nome + " " + r.cognome, label: "" };

    //PERSONA FISICA
    if(isNaN(r.codiceFiscale)) delega.label = r.nome + " " + r.cognome;

    //PERSONA GIURIDICA
    else delega.label = r.cognome;

    this.deleganteOptions.push(delega);

  }

  onSubmit(){
    this.fascicoloPct.registro = this.registroValue.descrizione;
    if(this.deleganteValue) this.fascicoloPct.cfDelegante = this.deleganteValue.id;
    else this.fascicoloPct.cfDelegante = null;
    this.dialogRef.close({modalEvent: 'submit', fascicoloPct: this.fascicoloPct});
  }

  setRegistriOptions(options: PdaRegister[]){

    //swap label and description for comboModInput
    options.forEach((opt) => {
      let registry: PdaRegister = new PdaRegister();
      registry.descrizione = opt.label;
      registry.label = opt.descrizione;
      registry.id = opt.id;
      this.registroOptions.push(registry);
    })
    this.registroOptions = this.registroOptions.sort((a, b) => (a.label.localeCompare(b.label)));
    if(this.fascicoloPct.registro != null) {
      this.registroValue = this.registroOptions.filter((opt) => opt.descrizione == this.fascicoloPct.registro)[0];
      this.fascicoloPctForm.controls['registro'].setValue(this.registroValue);
    }
  }

  onChangeDeleganteSel(event: PdaRegister){
    this.deleganteValue = event;
    this.fascicoloPctForm.controls['delegante'].setValue(event);
  }

  onChangeRegistroSel(event: PdaRegister){
    this.registroValue = event;
    this.fascicoloPctForm.controls['registro'].setValue(event);
  }

}
